import FetchInterceptor from "configs/FetchInterceptor";

class GiftServices {
  static async getAll(reqBody) {
    const apiUrl = "/core/v2/discount/giftcustom/get/all";
    const response = await FetchInterceptor.post(apiUrl, reqBody);
    return response;
  }

  static async getById(id) {
    const apiUrl = `/core/v2/discount/giftcustom/get/${id}`;
    const response = await FetchInterceptor.get(apiUrl);
    return response;
  }

  static async add(reqBody) {
    const apiUrl = "/core/v2/discount/giftcustom/create";
    const response = await FetchInterceptor.post(apiUrl, reqBody);
    return response;
  }

  static async update(id, reqBody) {
    const apiUrl = `/core/v2/discount/giftcustom/update/${id}`;
    const response = await FetchInterceptor.post(apiUrl, reqBody);
    return response;
  }
}

export default GiftServices;
